import { Badge } from "@/components/ui/badge";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

interface ContactDetailsViewProps {
  contact: any;
}

export const ContactDetailsView = ({ contact }: ContactDetailsViewProps) => {
  const { session } = useAuth();
  
  const { data: assignedUser } = useQuery({
    queryKey: ['user', contact.assigned_to],
    queryFn: async () => {
      if (!contact.assigned_to || !session) return null;
      const { data, error } = await supabase
        .from('profiles')
        .select('full_name, email')
        .eq('id', contact.assigned_to)
        .maybeSingle();
      
      if (error) throw error;
      return data;
    },
    enabled: !!contact.assigned_to && !!session
  });

  if (!session) return null;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium">Name</label>
          <p className="mt-1">{contact.name}</p>
        </div>
        <div>
          <label className="text-sm font-medium">Email</label>
          <p className="mt-1">{contact.email}</p>
        </div>
        <div>
          <label className="text-sm font-medium">Phone</label>
          <p className="mt-1">{contact.phone}</p>
        </div>
        <div>
          <label className="text-sm font-medium">Company</label>
          <p className="mt-1">{contact.company}</p>
        </div>
        <div>
          <label className="text-sm font-medium">Role</label>
          <p className="mt-1">{contact.role}</p>
        </div>
        <div>
          <label className="text-sm font-medium">Location</label>
          <p className="mt-1">{contact.city}, {contact.country}</p>
        </div>
        <div>
          <label className="text-sm font-medium">Website</label>
          <p className="mt-1">{contact.website}</p>
        </div>
        <div>
          <label className="text-sm font-medium">Lead Source</label>
          <p className="mt-1">{contact.lead_source}</p>
        </div>
        <div>
          <label className="text-sm font-medium">Category</label>
          <p className="mt-1">
            <Badge variant={
              contact.category === "active" ? "default" :
              contact.category === "prospect" ? "secondary" : "outline"
            }>
              {contact.category}
            </Badge>
          </p>
        </div>
        <div>
          <label className="text-sm font-medium">Assigned To</label>
          <p className="mt-1">
            {assignedUser ? (assignedUser.full_name || assignedUser.email) : 'Unassigned'}
          </p>
        </div>
      </div>
    </div>
  );
};